import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getTokens,
  isAuthenticated as isCognitoAuthenticated,
  decodeJwtPayload,
} from "@vault/cognito-auth";
import {
  selectCurrentToken,
  selectCurrentUser,
  setCredentials,
} from "../features/auth/authSlice";

const usePersistLogin = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectCurrentToken);
  const user = useSelector(selectCurrentUser);

  useEffect(() => {
    if (!token && isCognitoAuthenticated()) {
      const tokens = getTokens();
      if (tokens?.idToken) {
        const decoded = decodeJwtPayload(tokens.idToken);
        dispatch(
          setCredentials({
            token: tokens.idToken,
            uid: decoded.sub,
            roles: decoded.rls ? decoded.rls.split("|") : [],
          })
        );
      }
    }
  }, [token, dispatch]);

  const hasStoredSession = isCognitoAuthenticated();

  return { token, user, refreshToken: hasStoredSession };
};

export default usePersistLogin;
